import { ApiError, apiFetch } from "@/api/fetch";
import { v1ErrorMessage } from "@/features/claim-hunter/api/claimHunter";
import type { ExpertsSearchRequest, ExpertsSearchResponse } from "../types";

export const searchExperts = async (
  body: ExpertsSearchRequest,
  signal?: AbortSignal,
): Promise<ExpertsSearchResponse> => {
  const response = await apiFetch("/v1/experts/search", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    signal,
  });
  if (!response.ok) throw new ApiError(await v1ErrorMessage(response), response.status);
  return (await response.json()) as ExpertsSearchResponse;
};
